import React, { useState } from "react";
import { SlackApi } from "../../services/userService";
import { useDispatch } from "react-redux";
import { showAppAlert } from "../../store/reducers/appreducer";
const Cta = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
  });
  const [inquiryType, setInquiryType] = useState("");
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const openDemoModal = () => {
    setInquiryType("Demo Request");
    setIsModalOpen(true);
  };
  
  const openContactModal = () => {
    setInquiryType("Contact Request");
    setIsModalOpen(true);
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      const inquiryData = {
        name: formData.name,
        email: formData.email,
        companyName: formData.company,
        inquiryType: inquiryType, 
        message: formData.message,
      };
      
      // Call the SlackApi function
      const response = await SlackApi(inquiryData);
      console.log("Form submitted successfully:", response);
      dispatch(
        showAppAlert({
          show: true,
          alertType: "success",
          alertMessage: "Form submitted successfully",
        })
      );
      // Optionally, you can handle the response here
      // Reset form and close modal on success
      setFormData({
        name: "",
        email: "",
        company: "",
        message: "",
      });
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error submitting form:", error.message);
      // You might want to show an error message to the user here
      dispatch(
        showAppAlert({
          show: true,
          alertType: "error",
          alertMessage: error.message,
        })
      );
    }
  };

  return (
<div className="flex flex-col justify-center items-center">
  <div className="w-full  text-center space-y-6 p-12 bg-white shadow-md rounded-xl">
    {/* Main Heading */}
    <div className="text-center">
      <h1 className="text-2xl md:text-4xl font-bold text-blue-500 max-w-xl mx-auto">
        Ready to Transform Your Hiring?
      </h1>
      <p className="text-lg md:text-xl italic text-slate-600 mt-2 max-w-xl mx-auto">
        Join thousands of users who are already experiencing the future of AI-Powered Recruitment Solutions
      </p>
    </div>

        {/* Action Buttons */}
        <div className="flex justify-center space-x-4 mt-8">
          <button
            onClick={() => openDemoModal()}
            className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            Request Demo
          </button>
          <button
            onClick={() => openContactModal()}
            className="px-6 py-3 border-2 border-blue-500 text-blue-500 rounded-lg hover:bg-blue-50 transition-colors"
          >
            Contact Us
          </button>
        </div>

        {/* Modal Dialog */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
              <h2 className="text-2xl font-bold mb-4 text-gray-800">
                 {inquiryType === "Demo Request" ? "Request a Demo" : "Contact Us"}
              </h2>

              <form onSubmit={handleSubmit} className="space-y-4">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Work Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  value={formData.company}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
                <textarea
                  name="message"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="4"
                  required
                ></textarea>

                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cta;